import { type ReactNode } from 'react';

import { Button } from '@livechat/design-system-react-components';

import { type BubbleStepContent } from '../interfaces';

import { REPLY_SUGGESTIONS_GIF, TAGS_PNG } from './constants';

export const BubbleStep: BubbleStepContent = {
  headerMessage: 'Welcome to the Chats section!',
  message: 'Dive into the sample chat to test key features and experience the power of automation.',
  cta: (handleNextStep: () => void, handleSkipTour?: () => void): ReactNode => (
    <>
      <Button kind="high-contrast" size="large" onClick={handleNextStep}>
        Take a tour
      </Button>
      <Button kind="plain" size="large" onClick={handleSkipTour}>
        Maybe later
      </Button>
    </>
  ),
};

export const ChatsListStep = {
  header: 'Manage ongoing chats',
  text: 'Stay on top of active conversations or jump in to supervise other agents.',
};

export const CustomerDetailsStep = {
  header: 'Get to know your customers',
  text: "See who you're chatting with, where they're from, and their browsing or chat history—all in one place.",
};

export const CannedResponsesStep = {
  header: 'Use shortcuts for faster replies',
  text: 'Set offer of the right reply at the right time. Or use # to access canned responses at any time.',
};

export const ReplySuggestionsStep = {
  header: 'Speed up replies with AI suggestions',
  text: 'Get reply suggestions tailored from your business sources, like your website, to respond quickly and accurately.',
  image: {
    src: REPLY_SUGGESTIONS_GIF,
    alt: 'Reply suggestions',
  },
};

export const TagsStep = {
  header: 'Enhance messages with AI',
  text: 'Let AI suggest or add tags automatically to keep your chats organized.',
  image: {
    src: TAGS_PNG,
    alt: 'Tags',
  },
};
